import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getApiBaseUrl } from "../../config";

// Mounted at /paystack (not /payments) on the backend - /payments is
// already taken by the ProofOfPayment router (a different resource: manual
// payment evidence, not an initiated Paystack transaction). See
// backend/src/app.ts.
export const paymentApi = createApi({
  reducerPath: "paymentApi",
  baseQuery: fetchBaseQuery({
    baseUrl: getApiBaseUrl(),
    credentials: "include",
    prepareHeaders: (headers, { getState }) => {
      const user = getState().user?.currentUser;
      const token = getState().companyProfile?.token;
      if (token) {
        headers.set("x-auth-token", token);
      } else if (user?.id) {
        headers.set("userid", user.id);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    initiatePayment: builder.mutation({
      query: ({ record_type, record_id, withhold_vat, withhold_wht, phone_number }) => ({
        url: "/paystack/initiate",
        method: "POST",
        body: { record_type, record_id, withhold_vat, withhold_wht, phone_number },
      }),
    }),
    getPaymentStatus: builder.query({
      query: (reference) => `/paystack/${reference}/status`,
    }),
  }),
});

export const { useInitiatePaymentMutation, useGetPaymentStatusQuery, useLazyGetPaymentStatusQuery } = paymentApi;
